import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { mergeMap } from 'rxjs/operators';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { OrderLifetimeRuleAction } from '../orderLifetimeRule.action';

type IDependencies = IClientApiDependencySegment;

export const exportOrderLifetimeRulesEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeRuleAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.api.exportOrderLifetimeRules().pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          OrderLifetimeRuleAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
